import { render, staticRenderFns } from "./AdminServiceHints.vue?vue&type=template&id=4a0a3d6d&scoped=true"
import script from "./AdminServiceHints.vue?vue&type=script&lang=js"
export * from "./AdminServiceHints.vue?vue&type=script&lang=js"
import style0 from "./AdminServiceHints.vue?vue&type=style&index=0&id=4a0a3d6d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0a3d6d",
  null
  
)

export default component.exports